import { Route, Routes } from "react-router-dom";

import New from "./new";
import View from "./view";
import PaymentSuccess from "./payment-success";

const Cession = () => {
  return (
    <Routes>
      <Route path="/new/*" element={<New />} />
      <Route path="/:id" element={<View />} />
      <Route path="/:id/payment-success" element={<PaymentSuccess />} />
    </Routes>
  );
};

export default Cession;
